function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 0.8,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.538 4.75a.936.936 0 01.274.663v16.212c0 .518-.42.938-.937.938H1.937A.938.938 0 011 21.625V1.937C1 1.42 1.42 1 1.938 1H14.4c.248 0 .487.099.662.275l3.476 3.475z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.281 7.817L5.297 8.83a.47.47 0 00.712-.058l2.022-2.831m3.282 1.622h3.75M4.281 12.504l1.016 1.014a.463.463 0 00.37.136.465.465 0 00.342-.194l2.022-2.83m3.282 1.62h3.75M4.281 17.192l1.016 1.014a.47.47 0 00.712-.058l2.022-2.831m3.282 1.621h3.75"
}));

function SvgGeneralCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23
  }, props), _ref);
}

export default SvgGeneralCard;